import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as re, useRef as l, useState as E, useMemo as f, useEffect as m } from "react";
import { c as te } from "./index-DkZ16bcJ.mjs";
import { g as $e, I as He, F as Ue, i as Ae } from "./focus-trap-react-CzdCUkYc.mjs";
import { l as Ge } from "./lodash-5ofSKtz3.mjs";
import { P as Ke } from "./popover-DAJRG9vG.mjs";
import { D as We } from "./date-picker-calendar-single-Ce3WY92H.mjs";
import { b as P, u as ze, g as _, c as Je, d as Qe, e as Xe, a as Ye } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import { m as Ze } from "./tss-DN0acMKN.mjs";
import { M as qe, d as et } from "./constants-CnFYFetN.mjs";
import { f as tt } from "./index-LyFokDcn.mjs";
import { u as nt } from "./index-B1qvqCCQ.mjs";
import { u as rt } from "./use-readable-context-BO-ExsvT.mjs";
function ne(n, r) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return {
    value: P(n, r).date
  };
}
function ot(n, r) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return {
    value: P(n, r).date,
    text: $e(n, r)
  };
}
function at(n, r) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return {
    value: P(n, r.value).date,
    text: r.inputValue
  };
}
function it(n) {
  return {
    error: n
  };
}
const st = Ze()(({ mode: n }) => ({
  root: {
    outline: n === qe.Dye ? `1px solid ${et.main}` : void 0
  }
})), ct = re(function({
  afterLabel: r,
  ariaDescribedby: w,
  biId: i,
  classes: y = {},
  className: O,
  DatePickerCalendarProps: oe = {},
  disabled: L,
  getDateDisabled: I,
  enableFlip: ae = tt.ifFeature("encore", !0, !1),
  errorMessage: ie,
  id: M,
  InputDateProps: N = {},
  inputProps: $ = {},
  label: se,
  labelPlacement: ce,
  maxDate: g,
  minDate: h,
  note: ue,
  notePlacement: le,
  onInputChange: H,
  onBlur: F,
  onChange: U,
  onCalendarDateSelect: A,
  onClose: G,
  onError: K,
  onOpen: W,
  onPopupToggle: z,
  open: s,
  renderDate: fe,
  required: R = !1,
  size: de,
  status: pe,
  value: v,
  variant: me = "form",
  viewMode: ge,
  warningMessage: he,
  width: ve,
  ...De
}, Ce) {
  const ke = l(null), D = l(null), [xe, be] = E(null), C = l(null), c = l(""), J = l(void 0), j = l(!0), { palette: T } = nt(), t = ze(), [d, Q] = E(!1), [X, Y] = E(!1), [Ee, Pe] = E(T.gray[100]), { classes: we } = st(), u = f(() => _(t, v), [t, v]), k = f(() => _(t, h), [t, h]), B = f(() => k || Je(t), [t, k]), x = f(() => _(t, g), [t, g]), V = f(() => x || Qe(t), [t, x]);
  m(() => {
    v && !u && console.warn("The provided 'DatePicker' component's 'value' prop is being ignored because it is invalid.");
  }, [v, u]), m(() => {
    h && !k && console.warn("The provided 'DatePicker' component's 'minDate' prop is being ignored because it is invalid.");
  }, [h, k]), m(() => {
    g && !x && console.warn("The provided 'DatePicker' component's 'maxDate' prop is being ignored because it is invalid.");
  }, [g, x]);
  const ye = $.ref || ke;
  m(() => {
    return window.addEventListener("click", e), () => {
      window.removeEventListener("click", e);
    };
    function e(p) {
      const o = p.target;
      C.current && C.current.contains(o) || D.current && D.current.contains(o) || b();
    }
  }), m(() => {
    if (j.current) {
      j.current = !1;
      return;
    }
    S(u, c.current);
  }, [t, u, R, B, V, I, c.current]);
  const Z = s || d, q = f(() => typeof M == "string" ? M.replaceAll(" ", "-") : Ge.uniqueId(), []);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: te(O, y.root, we.root),
      "data-fabric-component": De["data-fabric-component"],
      ref: Ce,
      children: [
        /* @__PURE__ */ a.jsx(
          He,
          {
            ...N,
            afterLabel: r,
            ariaDescribedby: w,
            biId: i && `${i}_date-picker_input-date`,
            calendarButtonRef: be,
            calendarId: q,
            className: te("fabInternal-DatePickerInput", N.className),
            disabled: L,
            errorMessage: ie,
            id: M,
            inputProps: {
              ...$,
              ref: ye
            },
            isPopoverOpen: Z,
            label: se,
            labelPlacement: ce,
            note: ue,
            notePlacement: le,
            onBlur: Oe,
            onChange: je,
            onInputChange: Ie,
            onPopupToggle: Se,
            ref: D,
            required: R,
            size: de,
            status: pe,
            value: u,
            variant: me,
            viewMode: ge,
            warningMessage: he,
            width: ve
          }
        ),
        /* @__PURE__ */ a.jsx(
          Ke,
          {
            anchorEl: xe,
            arrowFill: Ee,
            autofocus: !1,
            disableOuterClickOnClose: !0,
            hasCloseButton: !1,
            hasMaxWidth: !1,
            id: `date-picker-control-${q}`,
            isRounded: !0,
            modifiers: [
              {
                name: "flip",
                enabled: ae
                // enable to flip the placement of the popper if it collides with the viewport
              }
            ],
            noPadding: !0,
            onFlip: (e) => _e(e),
            open: s === void 0 ? d : s,
            placement: "bottom-start",
            ref: C,
            variant: "bordered",
            children: /* @__PURE__ */ a.jsx(
              Ue,
              {
                active: s,
                focusTrapOptions: {
                  clickOutsideDeactivates: !0,
                  delayInitialFocus: !0,
                  escapeDeactivates: !1,
                  initialFocus: !1,
                  tabbableOptions: { displayCheck: "none" }
                },
                paused: X,
                children: /* @__PURE__ */ a.jsx("div", { onKeyDown: Re, children: /* @__PURE__ */ a.jsx(
                  We,
                  {
                    ...oe,
                    autofocus: Z,
                    disabled: L,
                    getDateDisabled: ee,
                    maxDate: V,
                    minDate: B,
                    onChange: Me,
                    onMenuClose: Te,
                    onMenuOpen: Be,
                    renderDate: fe,
                    value: u
                  }
                ) })
              }
            )
          }
        )
      ]
    }
  );
  function Oe(e) {
    const p = D.current, o = C.current, Ne = [p, o].filter(Boolean);
    if (typeof F != "function")
      return;
    !Ae(Ne, e) && !F.__fabricInternalOnlySupressBlur && F();
  }
  function Ie(e) {
    typeof H == "function" && H(at(t, e));
  }
  function Me(e) {
    c.current = "", b(), typeof A == "function" && A(ot(t, e.value)), U(ne(t, e.value)), S(e.value, c.current);
  }
  function Fe() {
    Q(!1), G && G();
  }
  function S(e, p) {
    if (K) {
      if (j.current)
        return;
      const o = Xe(t, e, p, R, B, V, ee);
      o !== J.current && (K(it(o)), J.current = o);
    }
  }
  function Re(e) {
    e.key === "Escape" && !X && (e.preventDefault(), b());
  }
  function ee(e) {
    return I ? I(P(t, e)) : !1;
  }
  function je(e) {
    c.current = e.inputValue, U(ne(t, e.value)), S(e.value, c.current);
  }
  function Te() {
    Y(!1);
  }
  function Be() {
    Y(!0);
  }
  function Ve() {
    Q(!0), W && W();
  }
  function Se() {
    d ? b() : Le(), z && z();
  }
  function _e(e) {
    Pe(e.includes("bottom") ? T.gray[100] : T.common.white);
  }
  function b() {
    s === void 0 && d && Fe();
  }
  function Le() {
    s === void 0 && (d || Ve());
  }
}), Et = re(function(r, w) {
  let i = r;
  const { viewMode: y = !1 } = r, { isReadable: O } = rt();
  return (O || y) && (i = { ...r, viewMode: !0 }), /* @__PURE__ */ a.jsx(Ye, { children: /* @__PURE__ */ a.jsx(ct, { ...i, "data-fabric-component": "DatePicker", ref: w }) });
});
export {
  Et as D
};
//# sourceMappingURL=date-picker-FVIC1w4I.mjs.map
